import React from "react";
import { Label } from "@lwt-helix/controls";
import { Input } from '@lwt-helix/controls';
import PropTypes from 'prop-types';
import { tabs } from "../../constants/suggestedAgents";

export const FilterInput = ({
    className,
    dataLwtId,
    defaultValue,
    labelText,
    onChange,
    value,
    currentTabId,
}) => (
    <div className={`${className} mt-1 mb-3`}>
        <Label
            dataLwtId={`${dataLwtId}-label`}
            className='mb-1 helix-heading'
        >
            {labelText}
        </Label>
        <Input
            className=''
            dataLwtId={dataLwtId}
            defaultValue={defaultValue}
            type="text"
            maxLength={tabs[currentTabId]?.inputMaxLength}
            onChange={(event) => onChange(event.target.value)}
            value={value}
        />
    </div>
);

FilterInput.propTypes = {
    className: PropTypes.string,
    dataLwtId: PropTypes.string.isRequired,
    defaultValue: PropTypes.string,
    labelText: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
};
